import { PublicPage, PublicTopbar } from '@rockalingua/ui';

import SignUpButton from '../../components/SignUpButton/SignUpButton';
import Hero from '../../components/Hero/Hero';
import TrustedBy from '../../components/TrustedBy/TrustedBy';
import HowItWorks from './components/HowItWorks/HowItWorks';
import TeachersFeedback from '../../components/TeachersFeedback/TeachersFeedback';
import FAQs from '../../components/FAQs/FAQs';
import FooterCTA from '../../components/FooterCTA/FooterCTA';
import Footer from '../../components/Footer/Footer';

export default function PromoAPage() {
  const signUpButton = <SignUpButton>Start your free trial</SignUpButton>;
  const topBarButton = <SignUpButton>Free Trial</SignUpButton>;

  return (
    <PublicPage backgroundVariant="two-drops">
      <PublicTopbar href="#">{topBarButton}</PublicTopbar>
      <Hero
        button={signUpButton}
        title="Are you a Spanish Teacher?"
        subtitle="Stop spending hours planning lessons that fall flat."
        description="Rockalingua gives you 500+ ready-to-use activities — videos, songs, games and more — so you walk into class prepared in minutes."
      />
      <TrustedBy
        button={signUpButton}
        title="Trusted by 3,000+ schools worldwide"
      />
      <HowItWorks />
      <TeachersFeedback button={signUpButton} />
      <FAQs />
      <FooterCTA
        title="Make your Spanish class the one students talk about."
        subtitle="Join thousands of Spanish teachers who use Rockalingua every week."
        button={signUpButton}
      />
      <Footer />
    </PublicPage>
  );
}
